import { render } from "./sales-overview-component.vue?vue&type=template&id=3aec1cf2&scoped=true"
import script from "./sales-overview-component.vue?vue&type=script&lang=js"
export * from "./sales-overview-component.vue?vue&type=script&lang=js"

import "./sales-overview-component.vue?vue&type=style&index=0&id=3aec1cf2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aec1cf2"],['__file',"src/assets/js/vue/components/dashboard/sales-overview-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aec1cf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aec1cf2', __exports__)) {
    api.reload('3aec1cf2', __exports__)
  }
  
  module.hot.accept("./sales-overview-component.vue?vue&type=template&id=3aec1cf2&scoped=true", () => {
    api.rerender('3aec1cf2', render)
  })

}


export default __exports__